import { Close as CloseIcon } from "@mui/icons-material";
import {
	Box,
	Button,
	Drawer,
	FormControl,
	IconButton,
	MenuItem,
	Select,
	TextField,
	Typography
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';
import { useEffect, useState } from "react";
import { MIDIA_OPTIONS_TELEFONIA_CALL_CENTER } from "../../constants/midia";


const SidebarPhoneForm = ({open, onClose, handleSubmit, budgetInfo, motivoCancelamentoOptions, statusOptions}) => {
	const [observacoes, setObservacoes] = useState("");
	const [selectedStatus, setSelectedStatus] = useState(0);
	const [selectedMotivoCancelamento, setSelectedMotivoCancelamento] = useState(0)
	const [selectedMidia, setSelectedMidia] = useState(0);
	const [dtRetorno, setDtRetorno] = useState("")

	const midiaOptions = MIDIA_OPTIONS_TELEFONIA_CALL_CENTER;

	useEffect(() => {
		const dt_retorno = new Date()
		setDtRetorno(dt_retorno)
		setObservacoes(budgetInfo.observacoes)
		setSelectedStatus(budgetInfo.id_status || 0)
		setSelectedMotivoCancelamento(budgetInfo.id_motivo_cancelamento || 0)
	}, [budgetInfo]);

	const handleSubmitPhoneForm = (e) => {
		e.preventDefault();
		handleSubmit({
			selectedStatus,
			observacoes,
			// telefone,
			selectedMotivoCancelamento,
			selectedMidia,
    		dtRetorno: dtRetorno ? format(dtRetorno, "dd/MM/yyyy") : null
		})
		onClose();
	};

	const labelStyle = {
		fontWeight: 500,
		letterSpacing: "0.05em",
		color: "#172b4d",
	};							

	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			variant="persistent"
			container={document.getElementById("card-details")}
			sx={{
				"& .MuiDrawer-paper": { 
					border: "1px solid black",
					borderRight: "none",
					borderRadius: "8px 0px 0px 8px",
				}
			}}
		>
			<Box
				sx={{
					width: 350,
					p: 3,
					display: "flex",
					flexDirection: "column",
					gap: 2,
					justifyContent: "space-between",
					height: "100%"
				}}
				component="form"
				onSubmit={handleSubmit}
			>
				<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<Typography variant="h4">Cadastro Retorno</Typography>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Box>

				<Box sx={{display: "flex", flexDirection: "column", gap: "10px"}}>
					<FormControl required>
						<Typography variant="caption" sx={labelStyle}>
							Data de Retorno
						</Typography>
						<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
							<DatePicker
								inputFormat="dd/MM/yyyy"
								value={dtRetorno || null}
								onChange={(newDate) => setDtRetorno(newDate)}
								renderInput={(params) => <TextField {...params} />}
							/>
						</LocalizationProvider>
					</FormControl>
					<FormControl required>
						<Typography variant="caption" sx={labelStyle}>
							Motivo do acompanhamento
						</Typography>
						<Select
							value={selectedStatus}
							onChange={e => setSelectedStatus(e.target.value)}
							sx={{
								fontWeight: !selectedStatus ? 600 : 500,
								fontFamily: 'Montserrat'
							}}
						>
							<MenuItem
								value={0}
								sx={{
									fontWeight: 600,
									fontFamily: 'Montserrat',
								}}
							>
								Selecione o motivo do acompanhamento
							</MenuItem>
							{statusOptions.map(item => (
								<MenuItem
									key={item.id}
									value={item.id}
									sx={{
										fontWeight: 500,
										fontFamily: 'Montserrat',
									}}
								>
									{item.ds_status}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl required>
						<Typography variant="caption" sx={labelStyle}>
							Midia
						</Typography>
						<Select
							value={selectedMidia}
							onChange={e => setSelectedMidia(e.target.value)}
							sx={{
								fontWeight: !selectedMidia ? 600 : 500,
								fontFamily: 'Montserrat',
							}}
							required
						>
							<MenuItem
								value={0}
								sx={{
									fontWeight: 600,
									fontFamily: 'Montserrat',
								}}
							>
								Selecione a midia
							</MenuItem>
							{midiaOptions.map(item => (
								<MenuItem
									key={item.id}
									value={item.ds_midia}
									sx={{
										fontWeight: 500,
										fontFamily: 'Montserrat',
									}}
								>
									{item.ds_midia}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl>
						<Typography variant="caption" sx={labelStyle}>
							Motivo do cancelamento
						</Typography>
						<Select
							value={selectedMotivoCancelamento}
							onChange={e => setSelectedMotivoCancelamento(e.target.value)}
							sx={{
								fontWeight: !selectedMotivoCancelamento ? 600 : 500,
								fontFamily: 'Montserrat',
							}}
						>
							<MenuItem
								value={0}
								sx={{
									fontWeight: 600,
									fontFamily: 'Montserrat',
								}}
							>
								Selecione o motivo do cancelamento
							</MenuItem>
							{motivoCancelamentoOptions.map(item => (
								<MenuItem
									key={item.id}
									value={item.id}
									sx={{
										fontWeight: 500,
										fontFamily: 'Montserrat',
									}}
								>
									{item.ds_status}
								</MenuItem>
							))}
						</Select>
						<Typography variant="caption" sx={{ color: "#6b7280", mt: 0.5 }}>
							Não substitui o motivo do acompanhamento.
						</Typography>
					</FormControl>
					<FormControl>
						<Typography variant="caption" sx={labelStyle}>
							Observação
						</Typography>
						<TextField
							fullWidth
							multiline
							minRows={2}
							value={observacoes}
							onChange={(e) => setObservacoes(e.target.value)}
						/>
					</FormControl>
				</Box>
				<Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
					<Button variant="outlined" onClick={onClose}>
						Cancelar
					</Button>
					<Button type="submit" variant="contained" onClick={handleSubmitPhoneForm} disabled={!selectedStatus || !dtRetorno || !selectedMidia}>
						Salvar
					</Button>
				</Box>
			</Box>
		</Drawer>
	);
}

export default SidebarPhoneForm 